import { RCompaniesBrowse } from "@/pages/Layout/views/Expert/views/Companies/browse/RCompaniesBrowse";
import { RCompaniesTemplate } from "@/pages/Layout/views/Expert/views/Companies/template/RCompaniesTemplate";
import { RouteConfig } from "vue-router";

export const RExpertCompanies: RouteConfig = {
  path: "companies",
  component: () =>
    import(
      /* webpackChunkName: "expert-companies" */
      "./VExpertCompanies.vue"
    ),
  meta: {
    title: "Companies",
    icon: "business-outline",
    newIcon: "building-skyscraper",
  },
  children: [RCompaniesBrowse, RCompaniesTemplate],
};
